<template>
  <filtertron-tray-section
    v-if="tab.type === 'Contributors'"
    id="tab-configurator-contributors"
    :title="lang.get('tabs.configuration.contributors.label')"
    :initially-collapsed="true"
  >
    <div class="fields island">
      <div class="form-group">
        <label>{{ lang.get('tabs.form.min_contributors.label') }}</label>
        <input
          type="number"
          :value="tab.minContributors"
          class="form-control"
          @input="e => handleInput('minContributors', toInt(e.target.value))"
        />
      </div>
      <div class="form-group">
        <label>{{ lang.get('tabs.form.max_contributors.label') }}</label>
        <input
          type="number"
          :value="tab.maxContributors"
          class="form-control"
          @input="e => handleInput('maxContributors', toInt(e.target.value))"
        />
      </div>
    </div>
  </filtertron-tray-section>
</template>

<script>
import FiltertronTraySection from '@/lib/components/Filtertron/FiltertronTraySection';
import handleInputMixin from '../handle-input-mixin.js';
import toIntMixin from '../to-int-mixin.js';

export default {
  inject: ['lang'],
  components: {
    FiltertronTraySection
  },
  mixins: [handleInputMixin, toIntMixin],
  props: {
    tab: {
      type: Object,
      required: true
    }
  }
};
</script>
